// Keyed by platformAgentName: `amigo` on FoodAmigos, `assistant` on a partner's dashboard.
export default {
  name: {
    amigo: 'Amigo',
    assistant: 'Assistente',
  },
  close: {
    amigo: 'Fechar o Amigo',
    assistant: 'Fechar o assistente',
  },
  brand: 'Marca',
  // The header (D4): Chats opens the restaurant's chats in the panel, New chat starts an empty one.
  chats: 'Conversas',
  new_chat: 'Nova conversa',
  back: 'Voltar à conversa',
  // Other chats with answers the person hasn't read (QA45): the line under the header leads to Chats.
  news_elsewhere_one: 'Novas respostas noutra conversa',
  news_elsewhere_other: 'Novas respostas em {{count}} outras conversas',
};
